import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/allocation/_layout/reports/")({
  beforeLoad: () => {
    throw redirect({ to: "/allocation/reports/stores" })
  },
})
